const React = require('react');

module.exports = React.createClass({
	render(){
		var className = 'alert alert-' + (this.props.className || 'info');
		var closeBtn;

		if (this.props.onClose) {
			closeBtn = (
				<button onClick={this.props.onClose} className="close" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			);
		}

		return (
			<div {...this.props} className={className} >{closeBtn}{this.props.children}</div>
		);
	}
});


/** WEBPACK FOOTER **
 ** ./src/components/alert.js
 **/